import { io } from 'socket.io-client';

if (!process.env.REACT_APP_API_URL) throw new Error('REACT_APP_API_URL environment variable not defined.');

const socket = io(process.env.REACT_APP_API_URL, { secure: process.env.NODE_ENV === 'production' });

export default socket;
